import {FormikProps} from "formik";
import React, {FC, memo, useState} from "react";
import moment, {Moment} from "moment";
import {PossibleFormikPropsType} from "../CourseCreate/CourseCreateForm";
import CustomCalendar from "./CustomCalendar";
import {useGetAppSettingsQuery} from "../../../generated/graphql";

type IndividualDueDayProps = {
    formikProps: FormikProps<PossibleFormikPropsType>;
};

type Month = {label: string; monthNum: number /* ; disabled?: boolean */};

const IndividualDueDay: FC<IndividualDueDayProps> = ({formikProps}) => {
    const {values} = formikProps;
    // const firstCourseLessonDate = values.lessons[0].startDateTime;
    const firstInstallmentDate = values.dateOfFirstInstallment;
    const firstCourseLessonDate = values.lessons[0].startDateTime;
    const [selectedDate, setSelectedDate] = useState<Moment>(
        // moment(firstInstallmentDate ?? firstCourseLessonDate),
        moment(firstInstallmentDate),
    );
    const [initialSelectedMonth, setInitialSelectedMonth] = useState<
        number | undefined
    >(undefined);

    const {data: appSettingsData} = useGetAppSettingsQuery();

    React.useEffect(() => {
        console.log("=====> firstInstallmentDate", firstInstallmentDate);
        if (appSettingsData && !firstInstallmentDate) {
            const {settings} = appSettingsData;

            const dataFromSettings = {
                day: settings?.firstInstallmentDayOfMonth,
                month: settings?.firstInstallmentMonth,
            };

            const firstInstallmentMonth = dataFromSettings.month;
            const firstInstallmentDayOfMonth = dataFromSettings.day;

            const monthOfFirstCourseLesson = moment(
                firstCourseLessonDate,
            ).month();

            let inputDate = moment(firstCourseLessonDate);

            inputDate = inputDate.set(
                "month",
                monthOfFirstCourseLesson + firstInstallmentMonth,
            );

            // if firstInstallmentDayOfMonth is greater than the last day of the month, set it to the last day of the month
            if (firstInstallmentDayOfMonth > inputDate.endOf("month").date()) {
                inputDate = inputDate.endOf("month");
            } else {
                inputDate = inputDate.set("date", firstInstallmentDayOfMonth);
            }

            console.log("inputDate", moment(inputDate).format("DD.MM.YYYY"));

            // setSelectedDate(moment(inputDate));

            if (
                formikProps.values.dateOfFirstInstallment !==
                inputDate.toISOString()
            ) {
                setSelectedDate(moment(inputDate));
                setInitialSelectedMonth(
                    monthOfFirstCourseLesson + firstInstallmentMonth,
                );
                formikProps.setFieldValue(
                    "dateOfFirstInstallment",
                    inputDate.toISOString(),
                );
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // THIS IS INTENTIONAL SO IT DOESN'T RUN ON EVERY RENDER

    // DEBUG ------------------------------------------------------------------------------------------------------------------------------
    const handleSelection = (date: Moment) => {
        const isoString = date.toISOString();

        formikProps.setFieldValue("dateOfFirstInstallment", isoString);
    };

    // const handleSelection = (date: Moment) => {
    //     const test = moment(date).format("YYYY-MM-DDTHH:mm:ss.SSSSZ");

    //     formikProps.setFieldValue("dateOfFirstInstallment", test);
    // };

    // DEBUG ------------------------------------------------------------------------------------------------------------------------------

    return (
        <div>
            <CustomCalendar
                firstCourseLessonDate={firstCourseLessonDate}
                selectedDate={selectedDate}
                setSelectedDate={(date: Moment) => {
                    setSelectedDate(date);
                    handleSelection(date);
                }}
                initialSelectedMonth={initialSelectedMonth}
            />
        </div>
    );
};

export default memo(IndividualDueDay);
